// src/XpressBazaar.jsx
import React from 'react';
import Layout from '../../components/layout';
import { Link } from 'react-router-dom';

function XpressBazaar() {
    return (
        <Layout>

            <div className="font-sans text-gray-800">
                {/* Navbar */}
                <nav className="bg-blue-600 text-white p-4 sticky top-0 z-10">
                    <div className="container mx-auto flex justify-between items-center">
                        <h1 className="text-2xl font-bold">XpressBazaar</h1>
                        <div className="space-x-4">
                            <a href="#features" className="hover:underline">Features</a>
                            <a href="#advantages" className="hover:underline">Advantages</a>
                            <a href="/contact" className="hover:underline">Contact</a>
                        </div>
                    </div>
                </nav>

                {/* Hero Section */}
                <section className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-20">
                    <div className="container mx-auto text-center">
                        <h2 className="text-4xl md:text-5xl font-extrabold mb-4">
                            Empowering India’s Retailers with XpressBazaar
                        </h2>
                        <p className="text-lg md:text-xl mb-6">
                            AI-Driven Seller App on the ONDC Network – Sell Smart, Sell Everywhere
                        </p>
                        <Link to="https://ondcadmin.xpressbaazaar.com/dashboard">
                            <button className="bg-white text-blue-600 font-semibold py-2 px-6 rounded-lg hover:bg-gray-100 transition">
                                Get Started
                            </button>
                        </Link>
                    </div>
                </section>

                {/* Features Section */}
                <section id="features" className="py-16 bg-gray-100">
                    <div className="container mx-auto">
                        <h3 className="text-3xl font-bold text-center mb-12">Key Features</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 px-16">
                            <div className="bg-white p-6 rounded-lg shadow-md">
                                <h4 className="text-xl font-semibold mb-2">Seamless ONDC Onboarding</h4>
                                <p>Guided registration, AI-based document verification, and fast seller activation.</p>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-md">
                                <h4 className="text-xl font-semibold mb-2">Smart Catalog Management</h4>
                                <p>AI-powered categorization, bulk uploads, and real-time inventory sync.</p>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-md">
                                <h4 className="text-xl font-semibold mb-2">Order & Logistics</h4>
                                <p>Unified order management with auto-integrated logistics and tracking.</p>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-md">
                                <h4 className="text-xl font-semibold mb-2">Payments & Settlements</h4>
                                <p>Real-time payment visibility and automatic reconciliation dashboards.</p>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-md">
                                <h4 className="text-xl font-semibold mb-2">AI & Analytics Suite</h4>
                                <p>Intelligent recommendations, sales trends, and predictive insights.</p>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-md">
                                <h4 className="text-xl font-semibold mb-2">Multilingual Support</h4>
                                <p>Available in Indian languages with a mobile-friendly, simple UX.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Advantages Section */}
                <section id="advantages" className="py-16">
                    <div className="container mx-auto">
                        <h3 className="text-3xl font-bold text-center mb-12">Business Advantages</h3>
                        <ul className="space-y-4 text-lg max-w-2xl mx-auto">
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-2">✔</span> Universal Marketplace Access – Reach more customers at zero cost.
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-2">✔</span> Zero Commission Selling – Retain more profit margins.
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-2">✔</span> AI-Driven Efficiency – Automate and scale operations effortlessly.
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-2">✔</span> Digital Inclusion – Bring small sellers into the digital economy.
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-2">✔</span> Data-Driven Growth – Insights for smarter, profitable scaling.
                            </li>
                        </ul>
                    </div>
                </section>

                {/* Call to Action */}
                <section className="bg-blue-600 text-white py-16">
                    <div className="container mx-auto text-center">
                        <h3 className="text-3xl font-bold mb-4">Ready to Transform Your Retail Business?</h3>
                        <p className="text-lg mb-6">Join XpressBazaar and sell across the ONDC network today!</p>
                        {/* <button className="bg-white text-blue-600 font-semibold py-2 px-6 rounded-lg hover:bg-gray-100 transition">
                            Sign Up Now
                        </button> */}
                    </div>
                </section>
            </div>
        </Layout>

    );
}

export default XpressBazaar;